import { H5, Body } from '../ui/Typography';

export default function PerformanceMetrics() {
  const metrics = [
    {
      title: 'Occupancy Rate',
      value: '78%',
      description: 'Current occupancy'
    },
    {
      title: 'Property Value Growth',
      value: '+10%',
      description: 'Year over year'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {metrics.map((metric, index) => (
        <div key={index} className="bg-white rounded-lg shadow-lg p-6">
          <div>
            <H5 className="text-gray-900 mb-3">{metric.title}</H5>
            <p className="font-kanit text-[32px] leading-[40px] text-primary">
              {metric.value}
            </p>
            <Body className="text-gray-600 mt-1">
              {metric.description}
            </Body>
          </div>
        </div>
      ))}
    </div>
  );
}